import { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { getContent } from "../lib/api";
import { Languages, X } from "lucide-react";

export default function Arabic() {
  const { t } = useApp();
  const [letters, setLetters] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { getContent("arabic").then(setLetters); }, []);

  return (
    <div className="space-y-6 fade-in" data-testid="arabic-page">
      <header className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-nour-primary text-white flex items-center justify-center"><Languages className="w-6 h-6" /></div>
        <div>
          <h1 className="font-heading text-2xl font-bold">{t.arabic}</h1>
          <p className="text-sm text-nour-text2">28 lettres · 4 formes</p>
        </div>
      </header>

      <div className="grid grid-cols-4 sm:grid-cols-6 gap-3" data-testid="letters-grid">
        {letters.map(l => (
          <button
            key={l.id}
            onClick={() => setActive(l)}
            data-testid={`letter-${l.id}`}
            className="nour-card p-4 flex flex-col items-center hover:bg-emerald-50 transition"
          >
            <div className="font-arabic-quran text-4xl text-nour-primary" dir="rtl">{l.letter}</div>
            <div className="text-xs text-nour-text2 mt-1">{l.translit}</div>
          </button>
        ))}
      </div>

      {active && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={() => setActive(null)} data-testid="letter-modal">
          <div className="nour-card p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-end"><button onClick={() => setActive(null)} data-testid="letter-modal-close"><X className="w-5 h-5"/></button></div>
            <div className="text-center">
              <div className="font-arabic-quran text-8xl text-nour-primary mb-3" dir="rtl">{active.letter}</div>
              <div className="font-heading text-2xl font-bold">{active.name}</div>
              <div className="text-sm text-nour-text2">[{active.translit}]</div>
            </div>
            <div className="mt-6 grid grid-cols-4 gap-3 text-center">
              {[
                ["isolated", t.isolated],
                ["initial",  t.initial],
                ["medial",   t.medial],
                ["final",    t.final]
              ].map(([k, label]) => (
                <div key={k} className="nour-card p-3 bg-emerald-50">
                  <div className="font-arabic-quran text-3xl text-nour-primary" dir="rtl">{active.forms[k]}</div>
                  <div className="text-[10px] text-nour-text2 mt-1">{label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
